import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rcc-pagination"},[(_vm.pageCount > 1)?_c('div',{staticClass:"rcc-pagination__wrapper"},[_c(VPagination,{ref:"paginationRef",attrs:{"color":"white","value":_vm.page,"length":_vm.pageCount},on:{"input":function($event){return _vm.$emit('update:page', $event)}}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }